import { createVanIconComponent } from "./van"

const Hot = createVanIconComponent("hot")
export default Hot
